import { Injectable, inject } from "@angular/core";

import { GridParams } from "./grid-params";
import { GridSort } from "./grid-sort.model";

@Injectable()
export class GridSortingService {
  private gridParams = inject(GridParams);
  private sortingFields = inject<string[]>(
    GridSortingService.SORTING_FIELDS as any,
    { optional: true },
  );

  public static SORTING_FIELDS = "sortingFields";
  public currentSort: GridSort = new GridSort();

  constructor() {
    let currentSortingFields: string[] = [];
    let currentSortingOrder: string;

    for (const field of this.sortingFields) {
      const order: string = this.gridParams.getParam(this.fieldToParam(field));

      if (order === null) {
        continue;
      }

      currentSortingOrder = order;
      currentSortingFields.push(field);
    }

    const defaultSortingFields: string[] = currentSortingFields.filter(
      (field: string) =>
        this.gridParams.isDefaultParam(this.fieldToParam(field)),
    );

    if (
      defaultSortingFields.length > 0 &&
      defaultSortingFields.length !== currentSortingFields.length
    ) {
      // unset default sorting params if sorting is defined in query

      for (const field of defaultSortingFields) {
        this.gridParams.unsetParam(this.fieldToParam(field), true);
      }

      currentSortingFields = currentSortingFields.filter(
        (field: string) => defaultSortingFields.indexOf(field) === -1,
      );
    }

    this.currentSort = new GridSort(
      currentSortingFields.join(","),
      currentSortingOrder,
    );
  }

  public sortGrid(field: string, order: string) {
    if (!field) {
      return;
    }

    this.resetGridSorting();
    this.currentSort = new GridSort(field, order);
    this.setSorting(this.currentSort.field, this.currentSort.order);
  }

  private setSorting(fieldsName: string, order: string) {
    const fields: string[] = fieldsName.split(",");

    for (const field of fields) {
      this.gridParams.setParam(this.fieldToParam(field), order, false);
    }
    this.gridParams.setParam("page", 1);
  }

  private resetGridSorting() {
    Object.keys(this.gridParams.params).forEach((key) => {
      if (key.indexOf("sorting[") !== -1) {
        this.gridParams.unsetParam(key);
      }
    });
    Object.keys(this.gridParams.defaults).forEach((key) => {
      if (key.indexOf("sorting[") !== -1) {
        this.gridParams.unsetParam(key, true);
      }
    });
  }

  private fieldToParam(name: string): string {
    return "sorting[" + name + "]";
  }
}
